import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import FooterMenu, { Footer } from "./Footer";

const footerMenuData = [
  {
    title: "Quick Links",
    submenu: [
      { title: "Home", link: "/" },
      { title: "Solutions", link: "/solutions/brew-better" },
      { title: "Articles", link: "/articles" },
      { title: "Careers", link: "/careers" },
      { title: "Contact Us", link: "/contact" },
    ],
  },
  {
    title: "Support & Tools",
    submenu: [
      { title: "Helpdesk", link: "https://helpdesk.urbanbrew.in" },
      { title: "Schedule a Call", link: "/contact" },
      { title: "Get Started", link: "/tools/onboarding" },
    ],
  },
];

const UrbanBrewFooter = () => (
  <Footer theme="dark" className="urban-brew-footer creative-footer border-0">
    <div className="ub-footer-main">
      <Container>
        <Row className="g-4 g-lg-5 align-items-start">
          <Col xs={12} md={12} lg={4} className="ub-footer-brand">
            <img
              src="/UrbanBrew_Logo_White.png"
              alt="UrbanBrew logo — workplace refreshment solutions"
              className="ub-footer-logo"
            />
            <p className="ub-footer-tagline font-serif">
              Urban Brew — by Urban Beverages
              <br />
              Premium workplace refreshment systems designed for modern teams.
              <br /> <strong>Beyond Beverages.</strong>
            </p>
          </Col>

          <FooterMenu
            data={footerMenuData}
            xs={6}
            sm={6}
            md={6}
            lg={2}
            titleClass="ub-footer-heading"
            className="ub-footer-menu"
          />

          <Col xs={12} md={12} lg={4} className="ub-footer-contact">
            <span className="ub-footer-heading font-serif">Connect With Us</span>
            <p className="ub-footer-text font-serif">
              Urban Beverages, Vadodara, Gujarat
            </p>
            <p className="ub-footer-text font-serif mb-0">
              helpdesk@urbanbrew.in
              <br /> +91 89808 66366 / 466
            </p>
          </Col>
        </Row>
      </Container>
    </div>

    <div className="ub-footer-bar">
      <Container>
        <p className="ub-footer-copyright font-serif mb-0 text-center">
          © {new Date().getFullYear()} Urban Brew
          <strong> — Beyond Beverages</strong>
        </p>
      </Container>
    </div>
  </Footer>
);

export default UrbanBrewFooter;
